var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#BCC9D4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.528,
    cy: 1.538,
    rx: 1.528,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.472,
    cy: 1.538,
    rx: 1.528,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.528,
    cy: 7.692,
    rx: 1.528,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.472,
    cy: 7.692,
    rx: 1.528,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.528,
    cy: 14.462,
    rx: 1.528,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.472,
    cy: 14.462,
    rx: 1.528,
    ry: 1.538
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.8cd330327e45ba6d0995aa297d069d4f.svg";
export { ForwardRef as ReactComponent };